import { submitInteraction } from 'purchase-motions-api/mutation/ums';
import { UPGRADE_POINT_LOCATIONS } from '../constants/locations';
import { UPGRADE_BANNER_TYPES } from '../constants/ums';
export const trackPotentialBannerInteraction = ({
  pointType,
  upgradeKey
}) => {
  if (pointType && upgradeKey && Object.keys(UPGRADE_BANNER_TYPES).includes(pointType)) {
    return submitInteraction({
      upgradeKey
    });
  }
  return Promise.resolve();
};
export const isUpgradePoint = location => UPGRADE_POINT_LOCATIONS.includes(location);
export const getRepName = repInfo => {
  var _repInfo$name;
  return (_repInfo$name = repInfo === null || repInfo === void 0 ? void 0 : repInfo.name) !== null && _repInfo$name !== void 0 ? _repInfo$name : 'Not assigned';
};